module.exports = __webpack_public_path__ + "media/images/front/ogp-89234e872f5e40d24abbab3ff19bf76e.png";